import React, { useState } from "react";
import { X, Play } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1635108198165-1773945e506e?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1638976892251-efab1145436a?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1770086962001-3da4f60e7db5?auto=format&fit=crop&w=600",
    "https://images.pexels.com/photos/15060419/pexels-photo-15060419.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/5849029/pexels-photo-5849029.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.pexels.com/photos/7061061/pexels-photo-7061061.jpeg?auto=compress&cs=tinysrgb&w=600",
    "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1705321963943-de94bb3f0dd3?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1593786267440-550458cc882a?auto=format&fit=crop&w=600",
    "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=600"
  ];

  // Videos de Google Drive del cliente
  const projectVideos = [
    {
      id: "1Fer2rcA5o6fgB0gnu3fX6N9BSjN_i0D8",
      title: "Proyecto de Piso Epóxico 1",
      thumbnail: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0?auto=format&fit=crop&w=600",
      source: "gdrive"
    },
    {
      id: "1F5R_ILyOK0Q96caLfelT_nnypY5uN9ci",
      title: "Proyecto de Piso Epóxico 2",
      thumbnail: "https://images.unsplash.com/photo-1635108198165-1773945e506e?auto=format&fit=crop&w=600",
      source: "gdrive"
    },
    {
      id: "1LxwRLF7SjGXmPcOoSXIs6sn_taj0K0T5",
      title: "Proyecto de Piso Epóxico 3",
      thumbnail: "https://images.unsplash.com/photo-1638976892251-efab1145436a?auto=format&fit=crop&w=600",
      source: "gdrive"
    },
    {
      id: "1eNNjW2nmcX1E_58DFLI4BKk-S8llrsN7",
      title: "Proyecto de Piso Epóxico 4",
      thumbnail: "https://images.unsplash.com/photo-1770086962001-3da4f60e7db5?auto=format&fit=crop&w=600",
      source: "gdrive"
    },
    {
      id: "1TftJjtlRTLDgyX8H2EcccyH7mb3mo9Qf",
      title: "Proyecto de Piso Epóxico 5",
      thumbnail: "https://images.unsplash.com/photo-1771530789155-b1f03fbf82b5?auto=format&fit=crop&w=600",
      source: "gdrive"
    }
  ];

  const [selectedVideo, setSelectedVideo] = useState(null);

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <div className="h-1 w-16 bg-blue-600 mb-4 mx-auto"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Nuestros Proyectos</h2>
          <p className="text-lg text-gray-600">Explora nuestra galería de trabajos realizados</p>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="photos" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-8 bg-gray-200">
            <TabsTrigger 
              value="photos" 
              className="text-base data-[state=active]:bg-blue-600 data-[state=active]:text-white"
            >
              Fotos
            </TabsTrigger>
            <TabsTrigger 
              value="videos" 
              className="text-base data-[state=active]:bg-blue-600 data-[state=active]:text-white"
            >
              Videos
            </TabsTrigger>
          </TabsList>

          {/* Photos Tab */}
          <TabsContent value="photos" className="mt-0">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {galleryImages.map((image, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedImage(image)}
                  className="relative h-64 overflow-hidden rounded-lg cursor-pointer group"
                >
                  <img
                    src={image}
                    alt={`Gallery image ${index + 1}`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 pointer-events-none"></div>
                </div>
              ))}
            </div>
          </TabsContent>

          {/* Videos Tab */}
          <TabsContent value="videos" className="mt-0">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {projectVideos.map((video, index) => (
                <div
                  key={index}
                  onClick={() => setSelectedVideo(video)}
                  className="relative h-64 overflow-hidden rounded-lg cursor-pointer group bg-black"
                >
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover transition-all duration-500 group-hover:scale-110 group-hover:opacity-70"
                  />
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                      <Play className="text-white fill-white ml-1" size={28} />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 pointer-events-none">
                    <p className="text-white font-semibold">{video.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>

      {/* Image Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage}
            alt="Selected"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      {/* Video Modal */}
      {selectedVideo && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedVideo(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 z-10"
            onClick={() => setSelectedVideo(null)}
          >
            <X size={32} />
          </button>
          <div className="w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
            {selectedVideo.source === "gdrive" ? (
              <iframe
                width="100%"
                height="100%"
                src={`https://drive.google.com/file/d/${selectedVideo.id}/preview`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="autoplay"
                allowFullScreen
                className="rounded-lg"
              ></iframe>
            ) : (
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${selectedVideo.id}?autoplay=1`}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg"
              ></iframe>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;